import React from "react";
import "./addtocartbtn.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createOrder } from "../../appState/slices/order/orderSlice";

const AddtoCartBtn = ({
  name,
  action,
  disabled,
  type = "button",
  onClick,
}) => {
  const navigate = useNavigate();

  const actionforBtn = (e) => {
    if (onClick) {
      onClick(e);
    }

    if (action === "checkout") {
      navigate("/checkout");
    }
  };

  

  return (
    <button
      type={type}
      className="checkoutbtn"
      onClick={actionforBtn}
      disabled={disabled}
    >
      {name}
    </button>
  );
};

export default AddtoCartBtn;